import React, { createContext, useContext, useState } from "react";

const UploadContext = createContext();

export const useUpload = () => useContext(UploadContext);

export const UploadProvider = ({ children }) => {
  const [uploadState, setUploadState] = useState({
    isUploading: false,
    estimatedTime: null,
  });

  const startUpload = (estimatedTime) => {
    setUploadState({
      isUploading: true,
      estimatedTime,
    });
  };

  const finishUpload = () => {
    setUploadState({
      isUploading: false,
      estimatedTime: null,
    });
  };

  return (
    <UploadContext.Provider
      value={{
        uploadState,
        startUpload,
        finishUpload,
      }}
    >
      {children}
    </UploadContext.Provider>
  );
};
